/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientExtensionAdoptionRateStatQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ClientExtensionAdoptionRateStatQuery = { __typename: 'Query', clientEmployees?: { __typename: 'ClientEmployeeTypeConnection', edges: Array<{ __typename: 'ClientEmployeeTypeEdge', node?: { __typename: 'ClientEmployeeType', sessions?: { __typename: 'ClientEmployeeSessionTypeConnection', totalCount?: number | null } | null } | null } | null> } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const ClientExtensionAdoptionRateStatDocument = new TypedDocumentString(`
    query ClientExtensionAdoptionRateStat($clientId: UUID!) {
  clientEmployees(clientId: $clientId) {
    edges {
      node {
        sessions {
          totalCount
        }
      }
    }
  }
}
    `);

export const useClientExtensionAdoptionRateStatQuery = <
      TData = ClientExtensionAdoptionRateStatQuery,
      TError = unknown
    >(
      variables: ClientExtensionAdoptionRateStatQueryVariables,
      options?: Omit<UseQueryOptions<ClientExtensionAdoptionRateStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientExtensionAdoptionRateStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientExtensionAdoptionRateStatQuery, TError, TData>(
      {
    queryKey: ['ClientExtensionAdoptionRateStat', variables],
    queryFn: fetcher<ClientExtensionAdoptionRateStatQuery, ClientExtensionAdoptionRateStatQueryVariables>(ClientExtensionAdoptionRateStatDocument, variables),
    ...options
  }
    )};

useClientExtensionAdoptionRateStatQuery.getKey = (variables: ClientExtensionAdoptionRateStatQueryVariables) => ['ClientExtensionAdoptionRateStat', variables];

export const useInfiniteClientExtensionAdoptionRateStatQuery = <
      TData = InfiniteData<ClientExtensionAdoptionRateStatQuery>,
      TError = unknown
    >(
      variables: ClientExtensionAdoptionRateStatQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientExtensionAdoptionRateStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientExtensionAdoptionRateStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientExtensionAdoptionRateStatQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientExtensionAdoptionRateStat.infinite', variables],
      queryFn: (metaData) => fetcher<ClientExtensionAdoptionRateStatQuery, ClientExtensionAdoptionRateStatQueryVariables>(ClientExtensionAdoptionRateStatDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientExtensionAdoptionRateStatQuery.getKey = (variables: ClientExtensionAdoptionRateStatQueryVariables) => ['ClientExtensionAdoptionRateStat.infinite', variables];


useClientExtensionAdoptionRateStatQuery.fetcher = (variables: ClientExtensionAdoptionRateStatQueryVariables) => fetcher<ClientExtensionAdoptionRateStatQuery, ClientExtensionAdoptionRateStatQueryVariables>(ClientExtensionAdoptionRateStatDocument, variables);
